import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, ClockCircleOutlineIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';
import useAuditLogAffordanceVisible from 'app/audit-logs/useAuditLogAffordanceVisible';

const TOOLTIP_MESSAGE = 'View audit log';

export default function AuditLogIconButton({ onClick }) {
  const visible = useAuditLogAffordanceVisible();
  if (!visible) return null;

  return (
    <WithTooltip show title={TOOLTIP_MESSAGE}>
      <IconButton aria-label={TOOLTIP_MESSAGE} data-test-id="auditLogIconButton" onClick={onClick}>
        <ClockCircleOutlineIcon />
      </IconButton>
    </WithTooltip>
  );
}

AuditLogIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
